import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/BreakDownListTableActions";
import * as api from "../../api/breakDownDetailApi";
import { getTechList, getCostCenterList, getStatusList, getAreaList, getEquipmentSubList } from "../../api/breakDownTaskApi";
import { showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getBreakDownReasonGroup() {
    try {
        const { data } = yield api.getBreakdownReasonList();
        yield put(actions.setBreakDownListTable(data || undefined));
        if (data) {
            yield put(actions.getBreakDownEffectList());
        }
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownTableEffectList() {
    try {
        const { data } = yield api.getBreakdownEffectList();
        yield put(actions.setBreakDownEffectList(data || undefined));
        if (data) {
            yield put(actions.getTechList());
        }
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownTechList() {
    try {
        const { data } = yield getTechList();
        yield put(actions.setTechList(data || undefined));
        if (data) {
            yield put(actions.getCostCenter());
        }
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getCostCenter() {
    try {
        const { data } = yield getCostCenterList();
        yield put(actions.setCostCenter(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownData(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getListByStatusUnPlannedMaintenance(action.payload);
        yield put(actions.setBreakDownData(data || undefined));
        yield put(actions.getPoolList());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPoolList() {
    try {
        const { data } = yield api.getBreakdownPoolList();
        yield put(actions.setPoolList(data || undefined));
        yield put(actions.getStatusList());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownStatus() {
    try {
        const { data } = yield getStatusList();
        yield put(actions.setStatusList(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownTableAreaList() {
    try {
        const { data } = yield getAreaList();
        yield put(actions.setBreakDownTableArea(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakDownTableSubEquipmentList(action) {
    try {
        const { data } = yield getEquipmentSubList(action.payload);
        yield put(actions.setBreakDownTableSubEquipment(data || undefined));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_BREAK_DOWN_TABLE_REASON_GROUP, getBreakDownReasonGroup);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_TABLE_EFFECT_LIST, getBreakDownTableEffectList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_TABLE_TECHLIST, getBreakDownTechList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_TABLE_COST_CENTER, getCostCenter);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_TABLE_DATA, getBreakDownData);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_TABLE_POOL_LIST, getPoolList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_TABLE_STATUS_LIST, getBreakDownStatus);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_TABLE_AREA_LIST, getBreakDownTableAreaList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_TABLE_SUB_EQUIPMENT_LIST, getBreakDownTableSubEquipmentList);
}

const breakDownListTableSaga = [fork(watchAll)];

export default breakDownListTableSaga;
